import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fetchCustomerDropdown = createAsyncThunk(
    'trip/fetchCustomerDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getCustomerDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);
export const fetchCostCenterDropdown = createAsyncThunk(
    'trip/fetchCostCenterDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getCostCenterDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);
export const fetchVehiclesDropdown = createAsyncThunk(
    'trip/fetchVehiclesDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehiclesDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);
export const fetchAllTripsDropdown = createAsyncThunk(
    'trip/fetchAllTripsDropdown',
    async (search, { rejectWithValue }) => {
        try {
            const response = await apiService.getAllTripsDropdown(search);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);
export const fetchUsersDropdown = createAsyncThunk(
    'trip/fetchUsersDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getUsersDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);
export const fetchSupervisorsDropdown = createAsyncThunk(
    'trip/fetchSupervisorsDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getSupervisorsDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);
export const fetchBanksDropdown = createAsyncThunk(
    'trip/fetchBanksDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getBanksDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);
export const fetchProductsDropdown = createAsyncThunk(
    'trip/fetchProductsDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getProductsDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);

export const fetchVehiclesTrackingPlusDropdown = createAsyncThunk(
    'trip/fetchVehiclesTrackingPlusDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehiclesTrackingPlusDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);

export const fetchPartCategoriesDropdown = createAsyncThunk(
    'trip/fetchPartCategoriesDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartCategoriesDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);

export const fetchPartsMaterialDropdown = createAsyncThunk(
    'trip/fetchPartsMaterialDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartsMaterialDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);

export const fetchPartsModelDropdown = createAsyncThunk(
    'trip/fetchPartsModelDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartsModelDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);

export const fetchPartsMakesDropdown = createAsyncThunk(
    'trip/fetchPartsMakesDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartsMakesDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);

export const fetchPartsUnitsDropdown = createAsyncThunk(
    'trip/fetchPartsUnitsDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartsUnitsDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch data');
        }
    }
);

export const fetchInventoryPartsList = createAsyncThunk(
    'dropdowns/fetchInventoryPartsList',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getInventoryPartsList();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch parts list');
        }
    }
);

export const fetchVendorsDropdown = createAsyncThunk(
    'dropdowns/fetchVendorsDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getVendorsDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch vendors');
        }
    }
);

export const fetchFuelCompaniesDropdown = createAsyncThunk(
    'dropdowns/fetchFuelCompaniesDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getFuelCompaniesDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch fuel companies');
        }
    }
);

export const fetchTransporterHeadquarterCitiesDropdown = createAsyncThunk(
    'dropdowns/fetchTransporterHeadquarterCitiesDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getTransporterCitiesDropdown(true);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch headquarter cities');
        }
    }
);

export const fetchTransporterCitiesDropdown = createAsyncThunk(
    'dropdowns/fetchTransporterCitiesDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getTransporterCitiesDropdown(false);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch cities');
        }
    }
);

export const fetchTransporterVehicleTypesDropdown = createAsyncThunk(
    'dropdowns/fetchTransporterVehicleTypesDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getTransporterVehicleTypesDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch transporter vehicle types');
        }
    }
);

export const fetchThreePlTransporterDropdown = createAsyncThunk(
    'dropdowns/fetchThreePlTransporterDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getThreePlTransporterDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch transporter dropdown');
        }
    }
);

const initialState = {
    customerDropdownData: [],
    costCenterDropdownData: [],
    vehiclesDropdownData: [],
    allTripsDropdownData: [],
    vehiclesTrackingPlusDropdownData: [],
    usersDropdownData: [],
    supervisorsDropdownData: [],
    banksDropdownData: [],
    productsDropdownData: [],
    partCategoriesDropdownData: [],
    partsMaterialDropdownData: [],
    partsModelDropdownData: [],
    partsMakesDropdownData: [],
    partsUnitsDropdownData: [],
    inventoryPartsListData: [],
    vendorsDropdownData: [],
    fuelCompaniesDropdownData: [],
    transporterHeadquarterCitiesDropdownData: [],
    transporterCitiesDropdownData: [],
    transporterVehicleTypesDropdownData: [],
    threePlTransporterDropdownData: [],
    loading: false,
    error: null,
};

const DropdownSlice = createSlice({
    name: 'dropdowns',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomerDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCustomerDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.customerDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchCustomerDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.customerDropdownData = [];
            })
            .addCase(fetchCostCenterDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCostCenterDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.costCenterDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchCostCenterDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.costCenterDropdownData = [];
            })
            .addCase(fetchVehiclesDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVehiclesDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.vehiclesDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchVehiclesDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.vehiclesDropdownData = [];
            })
            .addCase(fetchAllTripsDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllTripsDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.allTripsDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchAllTripsDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.allTripsDropdownData = [];
            })

            .addCase(fetchVehiclesTrackingPlusDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVehiclesTrackingPlusDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.vehiclesTrackingPlusDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchVehiclesTrackingPlusDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.vehiclesTrackingPlusDropdownData = [];
            })

            .addCase(fetchUsersDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUsersDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.usersDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchUsersDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.usersDropdownData = [];
            })
            .addCase(fetchSupervisorsDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSupervisorsDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.supervisorsDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchSupervisorsDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.supervisorsDropdownData = [];
            })
            .addCase(fetchBanksDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBanksDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.banksDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchBanksDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.banksDropdownData = [];
            })
            .addCase(fetchProductsDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductsDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.productsDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchProductsDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.productsDropdownData = [];
            })
            .addCase(fetchPartCategoriesDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPartCategoriesDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.partCategoriesDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchPartCategoriesDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.partCategoriesDropdownData = [];
            })
            .addCase(fetchPartsMaterialDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPartsMaterialDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.partsMaterialDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchPartsMaterialDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.partsMaterialDropdownData = [];
            })
            .addCase(fetchPartsModelDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPartsModelDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.partsModelDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchPartsModelDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.partsModelDropdownData = [];
            })
            .addCase(fetchPartsMakesDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPartsMakesDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.partsMakesDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchPartsMakesDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.partsMakesDropdownData = [];
            })
            .addCase(fetchPartsUnitsDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPartsUnitsDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.partsUnitsDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchPartsUnitsDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.partsUnitsDropdownData = [];
            })
            .addCase(fetchVendorsDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVendorsDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.vendorsDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchVendorsDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.vendorsDropdownData = [];
            })
            .addCase(fetchInventoryPartsList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInventoryPartsList.fulfilled, (state, action) => {
                state.loading = false;
                state.inventoryPartsListData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchInventoryPartsList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.inventoryPartsListData = [];
            })
            .addCase(fetchFuelCompaniesDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFuelCompaniesDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.fuelCompaniesDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchFuelCompaniesDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.fuelCompaniesDropdownData = [];
            })

            .addCase(fetchTransporterHeadquarterCitiesDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTransporterHeadquarterCitiesDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.transporterHeadquarterCitiesDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchTransporterHeadquarterCitiesDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.transporterHeadquarterCitiesDropdownData = [];
            })

            .addCase(fetchTransporterCitiesDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTransporterCitiesDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.transporterCitiesDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchTransporterCitiesDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.transporterCitiesDropdownData = [];
            })

            .addCase(fetchTransporterVehicleTypesDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTransporterVehicleTypesDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.transporterVehicleTypesDropdownData = action.payload?.data || [];
                state.error = null;
            })
            .addCase(fetchTransporterVehicleTypesDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.transporterVehicleTypesDropdownData = [];
            })

            .addCase(fetchThreePlTransporterDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchThreePlTransporterDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.threePlTransporterDropdownData = action.payload?.data || action.payload || [];
                state.error = null;
            })
            .addCase(fetchThreePlTransporterDropdown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.threePlTransporterDropdownData = [];
            })
    },
});

export default DropdownSlice.reducer;
